import type { RumClient } from '@tcc/analytics';

const getRumClient = (): RumClient | undefined => window.DD_RUM;

export const startView = (
  name: string,
  service = 'fieldview-web---dmb-web',
  version = process.env.npm_package_version
) => {
  getRumClient()?.startView?.({ name, service, version });
};